import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '@/views/HomeView'
import LoginView from '../views/LoginView.vue'
import PageNotFound from '@/views/PageNotFound'
import PartnerView from '@/views/PartnerView'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home-page',
    component: HomeView,
    meta: {
      title: 'TM Еталон 📈 партнерство для успіху',
      layout: 'base-layout',
      description: 'TM Etalon - це компанія, що спеціалізується на дистрибуції більше ніж 26 000 товарних позицій. Наша мета - забезпечити вас якісними та надійними продуктами'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      layout: 'base-layout',
      description: 'Увійдіть до особистого кабінету, щоб керувати вашими даними, замовленнями та налаштуваннями. Швидкий і безпечний доступ до вашого акаунта!'
    }
  },
  {
    path: '/register',
    name: 'register',
    component: PartnerView,
    meta: {
      layout: 'base-layout',
      description: 'Зареєструйтеся в особистому кабінеті, щоб отримати доступ до управління даними, замовленнями та персональними налаштуваннями. Швидка і безпечна реєстрація!'
    }
  },
  {
    path: '/dashboard/profile',
    name: 'profile',
    meta: {
      title: 'ETALON | Налаштування ⚙️',
      layout: 'dashboard-layout'
    },
    component: () => import('../views/Profile/UserProfileView')
  },
  {
    path: '/dashboard/catalog',
    name: 'catalog',
    meta: {
      title: 'ETALON | Каталог товарів 📦',
      layout: 'dashboard-layout'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Catalog/CatalogView.vue')
  },
  {
    path: '/dashboard/catalog/:id',
    name: 'catalog-item',
    meta: {
      title: 'ETALON | Каталог товарів 📦',
      layout: 'dashboard-layout'
    },
    component: () => import('../views/Catalog/CatalogView.vue')
  },
  {
    path: '/dashboard/catalog/:id/products',
    name: 'catalog-products',
    meta: {
      title: 'ETALON | Каталог товарів 📦',
      layout: 'dashboard-layout'
    },
    component: () => import('../views/Products/CategoryProductsView.vue')
  },
  {
    path: '/dashboard/products',
    name: 'products',
    meta: {
      title: 'ETALON | Каталог товарів 📦',
      layout: 'dashboard-layout'
    },
    component: () => import('../views/Products/ProductsView.vue')
  },
  {
    path: '/dashboard/products/:id',
    name: 'product-item',
    meta: {
      title: 'ETALON | Каталог товарів 📦',
      layout: 'dashboard-layout'
    },
    component: () => import('../views/Products/ProductView.vue')
  },
  {
    path: '/dashboard/news',
    name: 'news',
    meta: {
      title: 'ETALON | Новинки ⚡️',
      layout: 'dashboard-layout'
    },
    component: () => import('../views/Products/NewProductsView')
  },
  {
    path: '/dashboard/specials',
    name: 'specials',
    meta: {
      title: 'ETALON | Акційні товари ⭐️',
      layout: 'dashboard-layout'
    },
    component: () => import('../views/Products/SpecialProductsView')
  },
  {
    path: '/dashboard/specials/:id',
    name: 'specials-item',
    meta: {
      title: 'ETALON | Акційні товари ⭐️',
      layout: 'dashboard-layout'
    },
    component: () => import('../views/Products/SpecialView')
  },
  {
    path: '/dashboard/favorites',
    name: 'favorites',
    meta: {
      title: 'ETALON | Обрані товари ❤️',
      layout: 'dashboard-layout'
    },
    component: () => import('../views/Products/FavoriteProductsView')
  },
  {
    path: '/dashboard/cart',
    name: 'cart',
    meta: {
      title: 'ETALON | Кошик 🛒',
      layout: 'dashboard-layout'
    },
    component: () => import('../views/Cart/CartView.vue')
  },
  {
    path: '/dashboard/orders',
    name: 'order-list',
    meta: {
      title: 'ETALON | Замовлення 📋',
      layout: 'dashboard-layout'
    },
    component: () => import('../views/Orders/OrderListView')
  },
  {
    path: '/dashboard/orders/:id',
    name: 'order-view',
    meta: {
      title: 'ETALON | Замовлення 📋',
      layout: 'dashboard-layout'
    },
    component: () => import('../views/Orders/OrderView')
  },
  {
    path: '/dashboard/article/:id',
    name: 'article-view',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Articles/ArticleView')
  },
  {
    path: '/dashboard/notifications',
    name: 'notification-list-view',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Notifications/NotificationListView')
  },
  {
    path: '*',
    meta: { layout: 'base-layout' },
    component: PageNotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
//   // Установка заголовка страницы
  document.title = to.meta.title || 'ETALON | Кабінет клієнта '
  const metaDescription = document.querySelector('meta[name="description"]')
  if (metaDescription) {
    metaDescription.setAttribute('content', to.meta.description || '')
  } else {
    // Если мета-тег отсутствует, создаем новый
    const meta = document.createElement('meta')
    meta.name = 'description'
    meta.content = to.meta.description || ''
    document.head.appendChild(meta)
  }
  next()
})

export default router
